export default "__VITE_ASSET__f2f8cf19__"